// #region imports

// --- Angular
import { Directive, TemplateRef  } from '@angular/core';

// #endregion

@Directive({
  selector: '[hsViewmode]'
})
export class ViewModeDirective {
  constructor(public tplRef: TemplateRef<any>) { }
}
